import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.STORYBOARD;
export const TOTAL_QUESTIONS = 8;
export const SCREEN_STATES = { progress: 0, story: 1, loading: 2 };
export const ONBOARDING_CODE = -1;
export const ONBOARDING_LEVELS = [-1, 0];
export const MAX_WRONG_STORY_ANSWERS = 3;
export const LEVEL_MASTERY_THRESHOLD = 6;

export const DROP_VALUES = {
  CORRECT: 'correct',
  INCORRECT: 'incorrect',
  NONE: '',
};

export const DROP_ZONE_EVENTS = {
  FORCE_DRAG_STYLES: 'FORCE_DRAG_STYLES',
  FORCE_HOVER_STYLES: 'FORCE_HOVER_STYLES',
};

export const ASSET_CATEGORIES = {
  ANIMATIONS: 'animations',
  SVG_HOMEBASES: 'homebases',
  SVG_SCENES: 'scenes',
  SVG_STICKERS: 'stickers',
};

export const ONBOARDING_AUTOMATED_INCORRECT_OPTION = 'a_swim_suit';

// validation expresion for string that contains ]] means it contains reveal words.
export const regexRevealWord = /(\]]*){2,}/;
